// src/utils/Canonicalize.tsx
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from '@/utils/router';
import { SERVICE_FAMILY } from '@/constants/geo';

const normalizeFamilyKey = (s: string): string => {
  let x = s;
  try {
    x = s.normalize('NFKC');
  } catch {}

  return x
    .replace(/\u200F|\u200E/g, '')
    .replace(/[\s-]/g, '')
    .replace(/['"`\u05F3]/g, '')
    .toLowerCase();
};

const DJ_FAMILY_KEYS: ReadonlySet<string> = new Set(
  [
    'תקליטן',
    'דיגיי',
    'דיג׳יי',
    'דיג׳י',
    'די גיי',
    'די ג׳יי',
    'די-גיי',
    'די-ג׳יי',
    'dj',
    'd.j',
    'd-j',
    'deejay',
    'djay',
  ].map(normalizeFamilyKey),
);

export function normalizeFamily(seg?: string | null): typeof SERVICE_FAMILY | null {
  if (!seg) return null;
  const v = normalizeFamilyKey(seg);
  return DJ_FAMILY_KEYS.has(v) ? SERVICE_FAMILY : null;
}

const safeJoinUrl = (pathname: string, search: string, hash: string) =>
  `${pathname}${search || ''}${hash || ''}`;

export const Canonicalize: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const origPath = location.pathname || '/';
    const search = location.search || '';
    const hash = location.hash || '';

    let p = origPath;

    // 1) normalize /index.html => /
    p = p.replace(/\/index\.html\/?$/i, '/');

    // 2) ensure trailing slash (בכל האתר)
    if (!p.endsWith('/')) p = `${p}/`;

    // 3) normalize family segment (הסכמה החדשה: segment ראשון)
    const parts = p.split('/').filter(Boolean); // ללא empty
    if (parts.length >= 1) {
      const norm = normalizeFamily(parts[0]);
      if (norm && norm !== parts[0]) {
        parts[0] = norm;
        p = '/' + parts.join('/') + '/';
      }
    }

    // 4) squeeze multiple slashes
    p = p.replace(/\/{2,}/g, '/');

    // 5) no-op if unchanged
    if (p !== origPath) {
      navigate(safeJoinUrl(p, search, hash), { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
};
